import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetSubscriptionModel } from "@factory/model/query-model-subscription";
import { subscriptionFormDefault } from "./form.default";
import { SubscriptionFormSchema } from "./form.rule";

export const useFormDefaultSubscription = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetSubscriptionModel | undefined) => {
    return !cachedValue
      ? subscriptionFormDefault
      : ({
          // tenant: cachedValue.tenant,
          member: cachedValue.member,
          service: cachedValue.service,
          // startDate: cachedValue.start_date,
          // endDate: cachedValue.end_date,
          amount: cachedValue.amount,
          isSubscription: Boolean(cachedValue.is_subscription),
        } as SubscriptionFormSchema);
  };

  return {
    getDefault,
  };
};
